import { IExercise } from '../../../core/models/exercise';

export const organizeExerciseField = (exercise: IExercise) => {
  if (exercise.alternatives) {
    exercise.alternatives = exercise.alternatives.map((alternative) => {
      alternative.id = alternative._id;
      return alternative;
    });

    exercise.exerciseType = exercise.exercise_type;
  }

  return exercise;
};
